import firebase from 'firebase';

export const logOut = () => firebase.auth().signOut();
